import * as ser from '../Common/SerUtil.js'
import { ComponentArray } from '../Common/ComponentArray.js'
import { setupClass } from '../Base.js'
import { InputComponent } from '../Common/InputComponent.js'
import { removeElem } from '../SharedUtils.js'
import { CustomWallMaterial } from '../Components/WallType.js'

/**
 * A library of custom components reusable across the project.
 * Currently holds custom wall/roof materials; more types may be added later.
 */
export class ComponentsLibrary extends InputComponent {
  init() {
    this.customMaterials = new ComponentArray(CustomWallMaterial, {
      // makeId: each new material needs a unique project id, since wall
      // layers reference it by getTypeId() (`custom_<id>`).
      creationFunc: () => { return CustomWallMaterial.create(true); }
    });

    this.serFields = [
      ser.arrayField('customMaterials', () => { return CustomWallMaterial.create(); }),
    ];
    this.childObjs = '$auto';
    this.objInfo = {
      _name: 'Components Library',
      path: 'components-library',
    };
  }

  // Creates a new CustomWallMaterial, without adding it to the library. Use
  // commitCustomMaterial() to add it once the user confirms they want to keep it.
  createNewCustomMaterial() {
    return CustomWallMaterial.create(true);
  }

  commitCustomMaterial(mat) {
    this.customMaterials.push(mat);
  }

  deleteCustomMaterial(mat) {
    removeElem(this.customMaterials, mat);
  }

  lookupCustomMaterial(typeId) {
    return this.customMaterials.find(mat => mat.getTypeId() === typeId) || null;
  }
}
setupClass(ComponentsLibrary);
